module.exports = __webpack_public_path__ + "img/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle600dia.2c88cf5f.png";